<template>
  <div class="chart-container community-usage-chart">
    <div class="chart-element" ref="chartContainer">
      
    </div>
  </div>
</template>

<script>
require('@chartisan/chartjs');
import moment from 'moment';
export default {
  name: "CommunityUsageChart",
  props: {
    community_name: {
      type: String,
      default: "",
    },
    base_url: {
      type: String,
      default: "",
    },
    initial_from_date: {
      type: String,
      default: "",
    },
    initial_to_date: {
      type: String,
      default: "",
    },
    url: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: "auto",
    },
    width: {
      type: String,
      default: "auto"
    }
  }, 
  data() {
    return {
      chart: {},
      from_date: {},
      to_date: {}
    };
  },
  mounted() {
    if (this.height !== "auto") {
      this.$refs.chartContainer.style.height = this.height;
    }
    if (this.width !== "auto") {
      this.$refs.chartContainer.style.width = this.width;
    }

    this.from_date = moment.unix(this.initial_from_date);
    this.to_date = moment.unix(this.initial_to_date);
    
    this.chart = new Chartisan({
      el: this.$refs.chartContainer,
      url: this.url,
      hooks: new ChartisanHooks()
          .responsive()
          .beginAtZero()
          .colors()
          .legend(false)
          .title({text: 'Utilities Usage', fontSize: 18})
          .custom(({data, merge, server}) => {
            this.refreshTitle(data, merge, server);
            return data;
          })
    });
    
    
    Livewire.on('datesChanged', new_dates => {
      if(new_dates.length === 2){
        let new_from_date = new_dates[0];
        let new_to_date = new_dates[1];
        console.log("Setting from date", new_from_date);
        this.from_date = moment(new_from_date);
        console.log(this.from_date.format('LLLL'));
        console.log(this.to_date.format('LLLL'));
        console.log("Setting to date", new_to_date);
        this.to_date = moment(new_to_date);
        console.log(this.from_date.format('LLLL'));
        console.log(this.to_date.format('LLLL'));
        this.refreshChart();
      }
    });

  },
  methods: {
    refreshTitle(data, merge, server){
      data.options.title.text = [server.chart.extra.community_name + " Usage", moment(server.chart.extra.from_date).format('LL') + " - " + moment(server.chart.extra.to_date).format("LL")];
    },
    refreshChart(){
      console.log("Updating chart", this.from_date, this.to_date);
      this.chart.options.url = this.base_url + "&from_date=" + this.from_date.unix() + "&to_date=" + this.to_date.unix();
      this.chart.update();
    }
  }
}
</script>

<style scoped>

</style>
